module.exports = __webpack_public_path__ + "img/yelp.9e936ce1.svg";